export default "/_next/static/images/ServiceBoardingCircleIcon-72c8919640a2f9253efe9109612150cc.svg";